// extracted by mini-css-extract-plugin
module.exports = {"root":"oil-recycling-page_root__gs5qY","heroAsideReserve":"oil-recycling-page_heroAsideReserve__KS7Bj"};